module.exports = __webpack_public_path__ + "static/media/face-with-tears-of-joy-svgrepo-com.276bc43d.svg";